export default "__VITE_ASSET__CfL7RQAg__";